// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"43d8b2d6","239":"e39fb35b","455":"1b991356","578":"4c46475d","857":"9ec5e701","977":"b0a4678a"}[chunkId] + ".chunk.js";
};